/* TT-REEL - the video reel's strip and player (sections/tt-video-reel.liquid), played the way
   the Moast app plays the same clips on the live store (Josh, 2026-10-19).

   Strip: assets/tt-lazy-video.js loads a card's clip when it nears the screen and plays it muted
   on a loop; this pauses each card again as it leaves the screen, so a long row is never decoding
   clips nobody can see, and steps the row with the arrows.

   Player: a tap opens that clip over the page with sound. A line along the top fills as it plays;
   up / down (buttons, arrow keys, a vertical swipe) move to the previous / next clip; the next
   one starts by itself when one ends; Esc, the close button or a tap outside closes it and gives
   focus back to the card. Only the clip on screen is loaded. */
(function () {
  document.querySelectorAll('[data-reel]').forEach(function (root) {
    var row = root.querySelector('[data-reel-row]');
    var cards = [].slice.call(root.querySelectorAll('[data-reel-open]'));
    var player = root.querySelector('[data-reel-player]');
    var video = root.querySelector('[data-reel-video]');
    var bar = root.querySelector('[data-reel-progress]');
    var muteBtn = root.querySelector('[data-reel-mute]');
    var srcs = [];
    try { srcs = JSON.parse(root.querySelector('[data-reel-srcs]').textContent) || []; } catch (e) { srcs = []; }
    if (!row || !cards.length) return;

    /* ---- a held reel (`hold`): pauses under the header, or with its bottom on screen when
       it is taller than the window ---- */
    if (root.classList.contains('ts-reel--hold')) {
      var wrap = root.querySelector('.ts-wrap');
      var fitHold = function () {
        root.style.removeProperty('--hold-top');
        var vh = window.innerHeight;
        /* clear of a product page's title bar and its progress strip */
        var now = document.querySelector('[data-pdp-now]');
        var css = parseFloat(getComputedStyle(wrap).top) || 0;
        var want = Math.max(css, now ? Math.round(now.getBoundingClientRect().bottom) + (vh < 760 ? 16 : 28) : 0);
        if (want !== css) root.style.setProperty('--hold-top', want + 'px');
      };
      window.addEventListener('resize', fitHold); window.addEventListener('load', fitHold); fitHold();
    }

    /* ---- strip ---- */
    if ('IntersectionObserver' in window) {
      var away = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!e.isIntersecting && !e.target.paused) e.target.pause(); });
      }, { threshold: 0 });
      row.querySelectorAll('video').forEach(function (v) { away.observe(v); });
    }
    function step(dir) {
      var first = row.querySelector('.ts-reel__clip');
      var w = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 14) : row.clientWidth;
      var n = Math.max(1, Math.floor(row.clientWidth / w));
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      if (dir > 0 && atEnd) { row.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      row.scrollBy({ left: dir * w * n, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-reel-prev]');
    var next = root.querySelector('[data-reel-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    function arrows() {
      if (prev) prev.disabled = row.scrollLeft <= 4;
      if (next) next.hidden = row.scrollWidth <= row.clientWidth + 4;
      if (prev) prev.hidden = row.scrollWidth <= row.clientWidth + 4;
    }
    row.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);
    arrows();

    /* ---- player ---- */
    if (!player || !video) return;
    /* The player lives on <body>: a section that animates (a transform, a filter) makes
       position: fixed relative to itself, which left the page undimmed behind the clip. */
    document.body.appendChild(player);
    var at = 0, opener = null, muted = false;
    function setMute(m) {
      muted = m; video.muted = m;
      player.classList.toggle('is-muted', m);
      if (muteBtn) muteBtn.setAttribute('aria-label', m ? 'Sound on' : 'Mute');
    }
    function show(i) {
      at = (i + srcs.length) % srcs.length;
      bar.style.width = '0%';
      video.src = srcs[at];
      video.muted = muted;
      var p = video.play();
      /* a browser that refuses sound starts it muted instead of not at all */
      if (p && p.catch) p.catch(function () { setMute(true); video.play().catch(function () {}); });
    }
    function open(i, from) {
      opener = from || null;
      player.hidden = false;
      document.documentElement.classList.add('ts-reel-open');
      row.querySelectorAll('video').forEach(function (v) { v.pause(); });
      setMute(false);
      show(i);
      var close = player.querySelector('.ts-reel__tools [data-reel-close]');
      if (close) close.focus({ preventScroll: true });
    }
    function close() {
      video.pause(); video.removeAttribute('src'); video.load();
      player.hidden = true;
      document.documentElement.classList.remove('ts-reel-open');
      if (opener) opener.focus({ preventScroll: true });
      /* the cards still on screen pick up their loops again */
      row.querySelectorAll('video').forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight && v.currentSrc) v.play().catch(function () {});
      });
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { open(+c.getAttribute('data-reel-open'), c); }); });
    player.querySelectorAll('[data-reel-close]').forEach(function (b) { b.addEventListener('click', close); });
    player.querySelectorAll('[data-reel-step]').forEach(function (b) { b.addEventListener('click', function () { show(at + +b.getAttribute('data-reel-step')); }); });
    if (muteBtn) muteBtn.addEventListener('click', function () { setMute(!muted); });
    video.addEventListener('click', function () { if (video.paused) video.play().catch(function () {}); else video.pause(); });
    video.addEventListener('timeupdate', function () { if (video.duration) bar.style.width = (100 * video.currentTime / video.duration).toFixed(2) + '%'; });
    video.addEventListener('ended', function () { show(at + 1); });
    document.addEventListener('keydown', function (e) {
      if (player.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
    });
    var y0 = null;
    player.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
    player.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var dy = e.changedTouches[0].clientY - y0; y0 = null;
      if (Math.abs(dy) > 50) show(at + (dy < 0 ? 1 : -1));
    }, { passive: true });
  });
})();
